import i18next from 'i18next'
import {useEffect, useState} from 'react'
import {Button, FloatingLabel, Form} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {
  postComment as createFindocCommend,
  getComment as fetchFindoComment,
} from 'src/api/modules/findoc'
import {useAppDispatch, useAppSelector} from 'src/redux/hooks'
import {notificationSelector, setNotification} from 'src/redux/slices/notificationSlices'
import swal from 'sweetalert'
import {CustomModal} from '../CustomModal'
import {SkeletonModal} from '../SkeletonModal/SkeletonModal'

export const ChatFindocModal = () => {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const {notification} = useAppSelector(notificationSelector)

  const [showModal, setShowModal] = useState(false)
  const [commentCust, setCommentCust] = useState<any>([])
  const [fullcomment, setFullcomment] = useState<any>([])
  const [isLoading, setIsLoading] = useState(true)

  const language = i18next.language as string

  /**
   * handler for getting findoc comment
   */
  const handleGetComment = () => {
    if (!notification) return
    if (notification?.type !== 'findoc') return

    fetchFindoComment(notification.parent_id)
      .then((res) => {
        const {read_only} = notification
        setFullcomment(res.data.data)
        setShowModal(read_only ? false : true)
      })
      .catch((err: any) => {
        const icon = 'error'

        if (err.response) {
          const title = err.response.data.message
          swal({icon, title})
          return
        }

        const title = err?.message || 'Internal server error'
        swal({icon, title})
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  /**
   * Handler for close modal
   */
  const handleCloseModal = () => {
    setShowModal(false)
    dispatch(setNotification(null))
  }

  /**
   * Handler for request new comment
   */
  const handlePostComment = () => {
    if (!notification) return
    if (notification?.type !== 'findoc') return

    createFindocCommend(language, {
      findoc_id: notification.parent_id,
      user_id: localStorage.getItem('user-id'),
      comment: commentCust,
      credentials: localStorage.getItem('credential'),
    })
      .then((res) => {
        handleGetComment()

        const title = `${t('Komentar Berhasil Ditambahkan')}`
        return swal({title, icon: 'success'})
      })
      .catch((error) => {
        const title = t(error.response.data.message)
        swal({title, icon: 'error'})
      })
      .finally(() => {
        setCommentCust('')
        handleCloseModal()
      })
  }

  /**
   * Invoke handleGetComment while the notification change
   */
  useEffect(() => {
    handleGetComment()
  }, [notification])

  /**
   * Reset notification while unmount
   */
  useEffect(() => {
    return () => {
      dispatch(setNotification(null))
    }
  }, [])

  return (
    <CustomModal
      title={notification?.title ?? ''}
      show={showModal}
      size='lg'
      centered
      onHide={handleCloseModal}
    >
      {isLoading ? (
        <SkeletonModal />
      ) : (
        <>
          <FloatingLabel controlId='floatingTextarea2' label={t('Comment')}>
            <Form.Control
              as='textarea'
              placeholder={t('Tinggal-pesan')}
              value={commentCust}
              style={{height: '100px'}}
              onChange={(e: any) => setCommentCust(e.target.value)}
            />
          </FloatingLabel>

          <div className='d-flex justify-content-end'>
            <Button variant='primary' className='mt-3 mb-3' onClick={() => handlePostComment()}>
              {t('Tambah')}
            </Button>
          </div>

          {fullcomment?.length > 0 && (
            <div className='table-responsive mt-10 bdr'>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-bold w-100 align-items-center'>
                    <th className='td-3 text-center'>{t('no')}</th>
                    <th className='td-3 text-center'>{t('order-tanggal')}</th>
                    <th className='td-3 text-center'>{t('order-user')}</th>
                    <th className='td-3 text-center'>{t('Chat')}</th>
                  </tr>
                </thead>
                {fullcomment?.map((item: any, _index: number) => (
                  <tbody key={item?.id ?? _index}>
                    <tr className='w-100 align-items-center'>
                      <td className='td-150 text-center'>{_index + 1}</td>
                      <td className='td-150 text-center'>{item.created_at?.slice(0, 10)}</td>
                      <td className='td-150 text-center'>{item.user?.name}</td>
                      <td className='td-60 text-center'>
                        <div style={{textAlign: 'justify', padding: '0 0.775rem'}}>
                          {item.comment}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                ))}
              </table>
            </div>
          )}
        </>
      )}
    </CustomModal>
  )
}
